module.exports = __webpack_public_path__ + "img/Strawberry Horn Ice Cream.83a1b39a.png";